<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button (click)="back()"
                            class="btn btn-primary btn-back top-back-button"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Profile</div>
                    <p id="addthereco"><span>&nbsp;</span></p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>

                <div class="row w100 m-auto">
                    <div class="m-auto">

                        <div>
                            <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                            <div class="mb-4">
                                <div class="profile-link" (click)="userAction('contactInfo')">
                                    Contact Info
                                </div>
                            </div>

                            <div class="mb-4">
                                <div class="profile-link" (click)="userAction('notifications')">
                                    Notification
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="profile-link" [ngClass]="{'disabled':!(userStoreService?.getUserProfile()?.paymentDevices?.length)}" (click)="userAction('paymentMethod')">
                                 Payment Methods
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="profile-link" [ngClass]="{'disabled':(!(userStoreService?.getUserProfile()?.billingAccounts?.dmvAccounts?.length)
                             && !(userStoreService?.getUserProfile()?.billingAccounts?.ptAccounts?.length)
                             &&!(userStoreService?.getUserProfile()?.billingAccounts?.btAccounts?.length)
                              )}" (click)="userAction('billingAccount')">
                                    Billing Accounts
                                </div>
                            </div>




                        </div>
                    </div>
                </div>


            </div>

            <div class="container mt-5  text-center">

                <a><button class="btn btn-primary  btn-continue m-auto" (click)="back()">Close</button></a></div>
        </div>
    </div>
</div>